import { render, staticRenderFns } from "./PerkShopUpgradeButton.vue?vue&type=template&id=1ce43eb4&scoped=true"
import script from "./PerkShopUpgradeButton.vue?vue&type=script&lang=js"
export * from "./PerkShopUpgradeButton.vue?vue&type=script&lang=js"
import style0 from "./PerkShopUpgradeButton.vue?vue&type=style&index=0&id=1ce43eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce43eb4",
  null
  
)

export default component.exports